/* =====================================================
   TM — Cart Drawer JS
   Archivo: assets/tm-cart-drawer.js
   Función: lógica custom del cart drawer TM
   Origen: patrón probado en snippets/tm-product-bundle.liquid
===================================================== */

(function () {
  if (window.tmCartDrawerUpsellBound) return;
  window.tmCartDrawerUpsellBound = true;

  document.addEventListener('click', async function (event) {
    const addBtn = event.target.closest('[data-cart-drawer-upsell-add]');
    if (!addBtn) return;

    event.preventDefault();

    const variantId = addBtn.dataset.variantId;
    if (!variantId) return;

    addBtn.disabled = true;
    const originalHTML = addBtn.innerHTML;
    addBtn.innerHTML = '<span style="opacity:.6">Agregando...</span>';

    try {
      const response = await fetch(
        '/cart/add.js?sections=cart-drawer,cart-icon-bubble',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        }
      );

      if (!response.ok) throw new Error('Error al agregar upsell');

      const cartData = await response.json();
      const parser = new DOMParser();

      /* Actualizar drawer */
      if (cartData.sections && cartData.sections['cart-drawer']) {
        const drawerDoc = parser.parseFromString(
          cartData.sections['cart-drawer'],
          'text/html'
        );

        const liveDrawer = document.querySelector('#CartDrawer');
        const newDrawer = drawerDoc.querySelector('#CartDrawer');

        if (liveDrawer && newDrawer) {
          liveDrawer.innerHTML = newDrawer.innerHTML;
        }
      }

      /* Actualizar bubble */
      if (cartData.sections && cartData.sections['cart-icon-bubble']) {
        const bubbleDoc = parser.parseFromString(
          cartData.sections['cart-icon-bubble'],
          'text/html'
        );

        const bubbleTarget = document.querySelector('#cart-icon-bubble');
        const bubbleHTML = bubbleDoc.querySelector('.shopify-section');

        if (bubbleTarget && bubbleHTML) {
          bubbleTarget.innerHTML = bubbleHTML.innerHTML;
        }
      }

      /* Mantener drawer abierto */
      const cartDrawerEl = document.querySelector('cart-drawer');

      if (cartDrawerEl) {
        cartDrawerEl.classList.remove('is-empty');
        cartDrawerEl.querySelector('.drawer__inner')?.classList.remove('is-empty');
        cartDrawerEl.querySelector('cart-drawer-items')?.classList.remove('is-empty');

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'tm-cart-drawer-upsell',
            productVariantId: Number(variantId),
            cartData
          });
        }

        setTimeout(() => {
          if (typeof cartDrawerEl.open === 'function') {
            cartDrawerEl.open(addBtn);
          }
        }, 150);
      }
    } catch (err) {
      console.error('[TM Cart Drawer Upsell]', err);

      addBtn.innerHTML = originalHTML;
      addBtn.disabled = false;
    }
  });
})();